import React from "react";

import styles from "./homeCard.module.css";

export default function HomeCard({
  className,
  cardClass,
  cardType = "",
  text,
  onClick,
  image,
  animationDelay = "0s",
}) {
  let cardTypeClass = "";

  switch (cardType) {
    case "big":
      cardTypeClass = styles.big;
      break;
    case "solo":
      cardTypeClass = styles.solo;
      break;
    case "roleplay":
      cardTypeClass = styles.roleplay;
      break;
    case "nivel":
      cardTypeClass = styles.nivel;
      break;
    default:
      cardTypeClass = "";
      break;
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${styles.card} ${styles[cardClass]} ${className} zoom-in ${cardTypeClass}`}
      style={{
        "--animation-delay": animationDelay,
        "--animation-duration": ".6s",
        "--animation-timming": "ease-out",
      }}
    >
      <div className={`${styles.icon}`}>
        <img src={image} alt="home-card" />
      </div>
      <div className={`${styles.text}`}>
        <h1 dangerouslySetInnerHTML={{ __html: text }}></h1>
      </div>
    </button>
  );
}
